exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".follwing_3pNCW {\n    padding: 10px 0 10px 40px;\n}\n\n.follwing_3pNCW > li {\n    padding: 10px 5px;\n}\n\n.reference_2TOeN {\n    text-align: center;\n}\n\n.gapSection2_fIuSs {\n    height: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"follwing": "follwing_3pNCW",
	"reference": "reference_2TOeN",
	"gapSection2": "gapSection2_fIuSs"
};